module.exports = __webpack_public_path__ + "img/clear-channel.c470630f.svg";